import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to interpolate variables in translation strings
export function interpolate(
  template: string,
  variables: Record<string, string | number>
): string {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    return variables[key]?.toString() || match;
  });
}

export const formatDate = (dateString: string) => {
  try {
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('/').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);

    const pad = (num: number) => String(num).padStart(2, '0');

    // خروجی: 1403/07/27، 09:40
    return `${year}/${pad(month)}/${pad(day)}، ${pad(hour)}:${pad(minute)}`;
  } catch {
    return dateString;
  }
};
